import { z } from 'zod';
export const audienceSplitSchema = z.object({
    name: z.string().min(1).max(200),
    description: z.string().max(5000).optional().nullable(),
    /** Lege lijst = kopieer alle contacten van de parent. */
    lead_ids: z.array(z.string().uuid()).max(5000).optional(),
    copy_segment_definition: z.boolean().default(true),
});
//# sourceMappingURL=audienceSplit.js.map